import { render, staticRenderFns } from "./CatalogoCorrectivo.vue?vue&type=template&id=5c431285&"
import script from "./CatalogoCorrectivo.vue?vue&type=script&lang=js&"
export * from "./CatalogoCorrectivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports